<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.workReport')"
    resource="work_reports"
    :actionColumnProps="{ width: 200 }"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '@/admin_grapes/work_reports.js';
import { displayText } from '@/custom_models_extend';
import DialogText from '@/components/dialog-text.vue';
import InquiryContent from './inquiry-content.vue';

@Component
export default class WorkReports extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {
    date: (new Date()).toISOString().split('T')[0]
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'date_eq',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      (this.roleKind !== 'salesman' && this.roleKind !== 'customer_service') && 'user',
      'date',
      {
        key: 'content',
        renderCell: (h, { props: { value } }) => {
          return <DialogText showAll={type === 'show'} value={value} title="当日内容" maxRow={3} />
        }
      },
      {
        key: 'plan',
        renderCell: (h, { props: { value } }) => {
          return <DialogText showAll={type === 'show'} value={value} title="次日计划" maxRow={3} />
        }
      },
      type === 'show' && 'files',
      {
        key: 'inquiry_content',
        renderCell: (h, { props: { value } }) => {
          return <DialogText showAll={type === 'show'} value={value} title="询盘内容" maxRow={3} />
        }
      },
      type === 'show' && {
        key: 'follow_records',
        renderCell: (h, { props: { value } }) => {
          return value.map(item => {
            return <div><bean-link keepNode to={{ name: 'follow_records.show', params: { id: item.id } }}>{displayText(item)}</bean-link></div>
          })
        }
      },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      {
        key: 'date',
        renderCell: {
          props: {
            pickerOptions: {
              disabledDate(time) {
                return time.getTime() > Date.now();
              },
            }
          }
        }
      },
      'content',
      'plan',
      {
        key: 'files',
        renderCell: {
          props: {
            accept: 'image/*,.csv,.pdf,.txt,.xlsx,.docx,.xls,.doc',
            type: ['image', 'csv', 'application/pdf', 'text/plain', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
            clipboard: true,
            drag: true,
          }
        }
      },
      {
        key: 'inquiry_content',
        renderCell: {
          component: (h, context) => <InquiryContent {...context} date={data.date} showCustomers />,
        }
      },
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      row.can_update && {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'work_reports.edit', params: { id: row.id } }
        }
      },
      row.can_destroy && {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'work_reports.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/work_reports',
    name: 'work_reports.index',
    component: WorkReports,
    props: {
      type: 'index',
    }
  },
  {
    path: '/work_reports/new',
    name: 'work_reports.new',
    component: WorkReports,
    props: {
      type: 'new',
    }
  },
  {
    path: '/work_reports/:id',
    name: 'work_reports.show',
    component: WorkReports,
    props: {
      type: 'show',
    }
  },
  {
    path: '/work_reports/:id/edit',
    name: 'work_reports.edit',
    component: WorkReports,
    props: {
      type: 'edit'
    }
  }
]
</script>
